export default class ConfirmationDialogController {
    public static readonly controllerName = 'ConfirmationDialogCtrl';

    public confirm: () => any;

    public init(_, submitPromise: () => any): void {
        this.confirm = () => submitPromise();
    }
}
